<template>
    <BasePanel
        headline="lang_LABEL_TRACKS_CAPTION_GLOC"
        :alvqa="alvqa"
    >
        <template v-slot:panelContent>
            <v-data-table
                :headers="headers"
                :items="listItems"
                :items-per-page="1000"
                hide-default-footer
                :header-props="{ sortIcon: '' }"
                :no-data-text="$t('lang_GENERAL_MESSAGE_NO_RECORDS_FOUND')"
                class="noMinWidth"
            >
            <!-- TOP SLOT -->
                <template v-slot:top>
                    <v-row class="pb-3">
                        <v-spacer></v-spacer>
                        <v-col cols="3">
                            <BaseButton 
                                @click="addNewRow"
                                :disabled="$route.params.alvId === 'new'"
                                label="lang_GENERAL_BUTTON_ADD_ROW"
                                block
                                :alvqa="alvqa + '-button-add-row'"
                            />
                        </v-col>
                    </v-row>
                </template>

            <!-- Headers -->
                <template v-for="(header, i) in headers" v-slot:[`header.${header.value}`]>
                    <span :alvqa="header.alvqa" :key="i">{{ header.text }}</span>
                </template>

            <!-- Items -->
                <template v-slot:[`item.azObject`]="{ item }">
                    <div :alvqa="alvqa + '-list-row-text-azobject'">
                        {{ $alvPlugin.getArtistOrPerformerName(item.azObject) }}
                    </div>
                </template>
                <template v-slot:[`item.split`]="{ item }">
                    <div :alvqa="alvqa + '-list-row-text-split'">
                        {{ item.split }}
                    </div>
                </template>
                <template v-slot:[`item.glocSalesType`]="{ item }">
                    <div :alvqa="alvqa + '-list-row-text-gloc-sales-type'">
                        {{ item.glocSalesType }}
                    </div>
                </template>
                <template v-slot:[`item.statementText`]="{ item }">
                    <div :alvqa="alvqa + '-list-row-text-statement-text'">
                        {{ item.statementText }}
                    </div>
                </template>
                <template v-slot:[`item.glocNotes`]="{ item }">
                    <div :alvqa="alvqa + '-list-row-text-notes'">
                        {{ item.glocNotes }}
                    </div>
                </template>

            <!-- Buttons -->
                <template v-slot:[`item.delete`]="{ item }">
                    <BaseIcon 
                        @click="deleteRow(item)"
                        icon="delete"
                        color="iconDelete"
                        tooltipText="lang_GENERIC_CAPTION_DELETE"
                        :alvqa="alvqa + 'list-row-icon-delete'"
                    />
                </template>
                <template v-slot:[`item.inlineEdit`]="{ item }">
                    <BaseIcon   
                        :alvqa="alvqa + '-list-row-icon-inline-edit'"
                        icon="edit" 
                        tooltipText="lang_GENERAL_CAPTION_ICON_EDIT"   
                        @click.stop="editInlineFunction(item)"
                    />
                </template>
            </v-data-table>
        </template>
    </BasePanel>
</template>

<script>
import BasePanel from '@/components/_base/BasePanel'
import BaseButton from '@/components/_buttons/BaseButton'
import BaseIcon from '@/components/_buttons/BaseIcon'

export default {
    name: "TracksGlocEditPanel",
    components: {
        BasePanel,
        BaseButton,
        BaseIcon
    },
    data() {
        return {
            alvqa: 'label-tracks-edit-form-panel-gloc'
        }
    },
    computed: {
        headers() {
            return [
                {
                    text: this.$t("lang_LABEL_TRACKS_GLOC_NAME"), 
                    align: "left", 
                    value: "azObject",
                    class: 'text-no-wrap',
                    sortable: false,
                    alvqa: this.alvqa + '-header-azobject'
                },
                {
                    text: this.$t("lang_LABEL_TRACK_GLOC_SPLIT"), 
                    align: "left", 
                    value: "split",
                    class: 'text-no-wrap',
                    sortable: false,
                    alvqa: this.alvqa + '-header-split'
                },
                {
                    text: this.$t("lang_GENERIC_CAPTION_SALES_TYPE"), 
                    align: "left", 
                    value: "glocSalesType",
                    class: 'text-no-wrap',
                    sortable: false,
                    alvqa: this.alvqa + '-header-gloc-sales-type'
                },
                {
                    text: this.$t("lang_LABEL_TRACK_GLOC_STATEMENT_STRING"), 
                    align: "left", 
                    value: "statementText",
                    class: 'text-no-wrap',
                    sortable: false,
                    alvqa: this.alvqa + '-header-statement-string'
                },
                {
                    text: this.$t("lang_GENERIC_CAPTION_NOTES"), 
                    align: "left", 
                    value: "glocNotes",
                    class: 'text-no-wrap',
                    sortable: false,
                    alvqa: this.alvqa + '-header-statement-notes'
                },
                {
                    text: '', 
                    value: 'inlineEdit',
                    align: 'right',
                    sortable: false,
                    width: "70px",
                    class: 'text-no-wrap'
                },
                {
                    text: "",
                    align: "right",
                    width: "70px",
                    value: "delete",
                    sortable: false,
                    class: 'text-no-wrap'
                }
            ]
        },

        listItems() { return this.$store.getters.getTracksGloc }
    },
    methods: {
        addNewRow() {
            this.$store.commit('setTracksGlocAzObjectOptions', [])
            this.$store.commit('setShowTracksGlocEditingDialog', true)
            this.$store.commit('setEditingDialogHeadline', this.$t('lang_GENERAL_CAPTION_NEW_ENTRY'))

            let defaultValues = JSON.parse(JSON.stringify(this.$store.getters.getDefaultTracksGloc)) 
            this.$store.commit('setTracksGlocEditingDialogDetails', defaultValues)
        },

        deleteRow(item) {
            this.$store.commit("setSelectedTracksGloc", item)
            this.$store.commit('setDeletionDialogContext', 'SelectedTracksGloc')
            this.$store.commit('setShowDeletionDialog', true)
        },

        editInlineFunction(item) {
            this.$store.commit('setSelectedTracksGloc', item.id)
            let detailsDeepCopy = JSON.parse(JSON.stringify(item))

            // set the copy in dialog details to edit
            this.$store.commit('setTracksGlocEditingDialogDetails', detailsDeepCopy)
            this.$store.commit('setTracksGlocAzObjectOptions', [item.azObject])
            this.$store.commit('setEditingDialogHeadline', this.$t("lang_GENERAL_CAPTION_EDITING_ENTRY"))
            this.$store.commit('setShowTracksGlocEditingDialog', true) 
        },
    }
}
</script>


<style>
    .noMinWidth table {
        min-width: 0px !important;
        table-layout: fixed;
    }
</style>